module.exports = __webpack_public_path__ + "img/img5.2650a444.png";